import { Component } from '@angular/core';
import { SettingsOption } from 'src/app/enums/settings';
import { PermissionsService } from '../../services/permissions.service';

@Component({
    selector: 'app-settings',
    templateUrl: './settings.component.html',
    styleUrls: ['./settings.component.scss'],
})
export class SettingsComponent {
    readonly SettingsOption = SettingsOption;
    selectedComponent!: SettingsOption;

    componentMapping: Record<SettingsOption, string> = {
        [SettingsOption.GENERAL]: 'app-general',
        [SettingsOption.PRIORITATE_CERERE]: 'app-cerere-priority',
        [SettingsOption.STATUS_CERERE]: 'app-status',
        [SettingsOption.TIPURI_CERERE]: 'app-request-types',
        [SettingsOption.SABLOANE_CERERE]: 'app-cerere-sabloane',
        [SettingsOption.CATEGORII_DOCUMENTE]: 'app-document-category',
        [SettingsOption.TIPURI_DOCUMENTE]: 'app-document-type',
        [SettingsOption.TEMPLATE_DOCUMENTE]: 'app-document-template',
        [SettingsOption.CATEGORII_TEMPLATE]: 'app-template-categories',
        [SettingsOption.REGISTRE]: 'app-registre',
        [SettingsOption.OPERATORI]: 'app-operatori',
        [SettingsOption.ZILE_LIBERE]: 'app-zile-libere',
        [SettingsOption.PROGRAMARI_ACTIVITATI]: 'app-availability-management',
        [SettingsOption.MOTIVE_REFUZ]: 'app-motive-refuz',
    };

    componentKeys: string[] = Object.values(SettingsOption);

    onChange($event: { value: any }) {
        this.selectedComponent = $event.value;
    }

    selectedSection: any = null;

    constructor(private permissionsService: PermissionsService) {
        this.filterComponents();
    }

    filterComponents() {
        if (!this.permissionsService.hasPermission('dgaspc-module.settings.prioritati-cerere.list')) {
            this.componentKeys = this.componentKeys.filter(
                (item) => item !== SettingsOption.PRIORITATE_CERERE
            );
        }
        if (!this.permissionsService.hasPermission('dgaspc-module.settings.status-cerere.list')) {
            this.componentKeys = this.componentKeys.filter(
                (item) => item !== SettingsOption.STATUS_CERERE
            );
        }
        if (!this.permissionsService.hasPermission('dgaspc-module.settings.tip-cerere.list')) {
            this.componentKeys = this.componentKeys.filter(
                (item) => item !== SettingsOption.TIPURI_CERERE
            );
        }
        if (!this.permissionsService.hasPermission('dgaspc-module.settings.sablon-cerere.list')) {
            this.componentKeys = this.componentKeys.filter(
                (item) => item !== SettingsOption.SABLOANE_CERERE
            );
        }
        if (!this.permissionsService.hasPermission('dgaspc-module.settings.categorii-documente.list')) {
            this.componentKeys = this.componentKeys.filter(
                (item) => item !== SettingsOption.CATEGORII_DOCUMENTE
            );
        }
        if (!this.permissionsService.hasPermission('dgaspc-module.settings.tip-documente.list')) {
            this.componentKeys = this.componentKeys.filter(
                (item) => item !== SettingsOption.TIPURI_DOCUMENTE
            );
        }
        if (!this.permissionsService.hasPermission('dgaspc-module.settings.template-documente.list')) {
            this.componentKeys = this.componentKeys.filter(
                (item) => item !== SettingsOption.TEMPLATE_DOCUMENTE
            );
        }
        if (!this.permissionsService.hasPermission('dgaspc-module.documents.registre.list')) {
            this.componentKeys = this.componentKeys.filter(
                (item) => item !== SettingsOption.REGISTRE
            );
        }
        if (!this.permissionsService.hasPermission('dgaspc-module.settings.operatori.list')) {
            this.componentKeys = this.componentKeys.filter(
                (item) => item !== SettingsOption.OPERATORI
            );
        }
        if (!this.permissionsService.hasPermission('dgaspc-module.settings.template-categories.list')) {
            this.componentKeys = this.componentKeys.filter(
                (item) => item !== SettingsOption.CATEGORII_TEMPLATE
            );
        }
        if (!this.permissionsService.hasPermission('dgaspc-module.settings.zile-libere.list')) {
            this.componentKeys = this.componentKeys.filter(
                (item) => item !== SettingsOption.ZILE_LIBERE
            );
        }
        if (!this.permissionsService.hasPermission('dgaspc-module.settings.general.list')) {
            this.componentKeys = this.componentKeys.filter(
                (item) => item !== SettingsOption.GENERAL
            );
        }
        // if (!this.permissionsService.hasPermission('dgaspc-module.activities.manage')) {
        //     this.componentKeys = this.componentKeys.filter(
        //         (item) => item !== SettingsOption.PROGRAMARI_ACTIVITATI
        //     );
        // }
        if (!this.permissionsService.hasPermission('dgaspc-module.settings.motive-refuz.list')) {
            this.componentKeys = this.componentKeys.filter(
                (item) => item !== SettingsOption.MOTIVE_REFUZ
            );
        }
    }
}
